import React from "react";

import { getReviewChipConfig } from "../../../CONSTANTS/reviewChips";

/*
 * Shared body for every review popup. Renders the touchpoint's title +
 * subtitle and a single-select row of chip pills.
 *
 * Selecting a chip is only used to enable the popup's "Write a review" button —
 * the choice is not recorded anywhere.
 *
 * Props:
 *   - touchpoint:   one of REVIEW_TOUCHPOINTS; picks title/subtitle/chips.
 *   - selectedChip: the currently selected chip string (or null).
 *   - onSelect:     called with the chip string when a pill is clicked.
 */
const ReviewChips = ({ touchpoint, selectedChip, onSelect }) => {
  const { title, subtitle, chips } = getReviewChipConfig(touchpoint);

  return (
    <div>
      <p style={{ margin: 0, fontSize: "15px", fontWeight: 600, color: "#202223" }}>
        {title}
      </p>
      <p style={{ margin: "4px 0 16px", fontSize: "13px", color: "#6d7175" }}>
        {subtitle}
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {chips.map((chip) => {
          const isActive = chip === selectedChip;
          return (
            <button
              key={chip}
              type="button"
              onClick={() => onSelect(chip)}
              style={{
                cursor: "pointer",
                borderRadius: "16px",
                padding: "6px 14px",
                fontSize: "13px",
                lineHeight: 1.3,
                border: `1px solid ${isActive ? "#008060" : "#c9cccf"}`,
                background: isActive ? "#008060" : "#ffffff",
                color: isActive ? "#ffffff" : "#202223",
                transition: "background 0.1s ease, border-color 0.1s ease",
              }}
            >
              {chip}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewChips;
